import styled from 'styled-components';

export const RegistryList = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 14px;
  width: 70%;
  padding-top: 8px;
`;
